import DateRangeSchema, { DateRange } from '../schemas/DateRangeSchema'

export default function DateRangeVo(initData: unknown = {}): DateRange {
  return DateRangeSchema.validateSync(initData)
}
